import { gql } from '@apollo/client';

export const GET_PRINT_PUBLICATION_KEY = gql`
  query LocationPage_GetPrintPublicationKey($id: ID!) {
    printPublication(where: { id: $id }) {
      key
    }
  }
`;
